import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-right"
      expand={false}
      richColors={false}
      toastOptions={{
        style: {
          background: 'linear-gradient(135deg, rgba(20, 21, 35, 0.98) 0%, rgba(30, 32, 50, 0.98) 100%)',
          border: '1px solid rgba(108, 99, 255, 0.3)',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), 0 0 20px rgba(108, 99, 255, 0.15)',
          color: '#F8F9FC',
          fontSize: '14px',
          padding: '14px 16px',
          backdropFilter: 'blur(12px)',
        },
        classNames: {
          toast: "group toast",
          title: "font-semibold text-white",
          description: "text-white/70 text-sm",
          actionButton: "bg-brand-500 hover:bg-brand-600 text-white font-medium rounded-lg px-3 py-1.5",
          cancelButton: "bg-white/10 hover:bg-white/20 text-white/80 font-medium rounded-lg px-3 py-1.5",
          closeButton: "bg-white/10 hover:bg-white/20 border-white/10",
          success: "!border-emerald-500/50 !shadow-emerald-500/20",
          error: "!border-red-500/50 !shadow-red-500/20", 
          warning: "!border-amber-500/50 !shadow-amber-500/20",
          info: "!border-brand-500/50 !shadow-brand-500/20",
        },
      }}
      icons={{
        success: (
          <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center">
            <svg className="w-3 h-3 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        ),
        error: (
          <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
            <svg className="w-3 h-3 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        ),
        warning: (
          <div className="w-5 h-5 rounded-full bg-amber-500/20 flex items-center justify-center">
            <svg className="w-3 h-3 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        ),
        info: (
          <div className="w-5 h-5 rounded-full bg-brand-500/20 flex items-center justify-center">
            <svg className="w-3 h-3 text-brand-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        ),
        loading: (
          <div className="w-5 h-5 rounded-full bg-brand-500/20 flex items-center justify-center">
            <svg className="w-3 h-3 text-brand-400 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        ),
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
